import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class DeleteDatasourcesRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteDatasources', { ids: ids });
  }
}
